export default class URLUtil {
    /**
     * Get url param from current doc location
     * TODO: fix... es.util.url.getParam returns "null" if param not present
     * 
     * @param name 
     * 
     * @returns 
     */
    getParam(name: string): string {
        return decodeURIComponent((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [ , null ])[1]);
    }
    
    /**
     * 
     * @param name 
     * 
     * @returns 
     */
    getHashParam(name: string): string {
        return decodeURIComponent((RegExp(name + '=' + '(.+?)(&|$)').exec(location.hash) || [ , null ])[1]);
    }

    /**
     * 
     * @param key 
     * @param sourceURL 
     * 
     * @returns 
     */
    removeParam(key: string, sourceURL: string): string {
        let rtn = sourceURL.split("?")[0];
        let params_arr = [];
        const queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                const param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = rtn + "?" + params_arr.join("&");
        }

        return rtn;
    }

    setParam(url: string, key: string, value: string | number | boolean): string {
        if (!url) url = window.location.href;
        const re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi");

        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null) {
                return url.replace(re, '$1' + key + "=" + encodeURIComponent(value) + '$2$3');
            } else {
                const hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                    url += '#' + hash[1];
                }

                return url;
            }
        } else {
            if (typeof value !== 'undefined' && value !== null) {
                const separator = url.indexOf('?') !== -1 ? '&' : '?';
                const hash = url.split('#');
                url = hash[0] + separator + key + '=' + encodeURIComponent(value);
                if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                    url += '#' + hash[1];
                }

                return url;
            } else {
                return url;
            }
        }
    }
    
    /**
     * @function Stringify a url with JSON.stringify (if not a string already) but also perform an encodeURIComponent on it
     * 
     * @return str to be run through encodeURIComponent
     */
    stringify(s: any): string {
        // initially only on IE (see: TOR9-238) but required for Tomcat (see: TOR9-7786)
        if (typeof s != 'string') {
            s = JSON.stringify(s);
        }
        
        return encodeURIComponent(s);
    }
    
    /**
     * @function toParams
     * 
     * @param url 
     * @param ret 
     * @returns 
     */
    toParams(url: string, ret?: Record<string, string | string[]>): Record<string, string | string[]> {
        if (!ret) {
            ret = {};
        }
        
        // ignore hash
        let index = url.indexOf('#');
        if (index >= 0) {
            url = url.substring(0, index);
        }
        
        index = url.indexOf("?");
        if (index >= 0) {
            const parts = url.substring(index + 1).split("&");
            for (let p = 0; p < parts.length; p++) {
                const part = parts[p];

                index = part.indexOf("=");
                if (index > 0) {
                    let key = part.substring(0, index);
                    try {
                        key = decodeURIComponent(key);
                    } catch (e) {
                        // no action required
                    }

                    let value = part.substring(index + 1);
                    try {
                        value = decodeURIComponent(value);
                    } catch (e) {
                        // no action required
                    }

                    let existing = ret[key];
                    if (typeof existing == "string") {
                        ret[key] = [ existing, value ];
                    } else if (existing) {
                        existing.push(value);
                    } else {
                        ret[key] = value;
                    }
                }
            }
        }

        return ret;
    }
    
    /**
     * fromParams
     * 
     * @param params 
     * @param url 
     * @param override 
     * 
     * @returns 
     */
    fromParams(params: Record<string, any>, url?: string, override?: boolean): string {
        if (!url) {
            url = "";
        } else {
            const index = url.indexOf("?");
            if (index >= 0) {
                if (!override) {
                    const prevParams = this.toParams(url);
                    for (let key in params) {
                        const prevValue = prevParams[key];
                        const newValue = params[key];

                        if (typeof prevValue == "string") {
                            prevParams[key] = [ prevValue, newValue ];
                        } else if (prevValue) {
                            prevValue.push(newValue);
                        } else {
                            prevParams[key] = newValue;
                        }
                    }

                    params = prevParams;
                }

                url = url.substring(0, index + 1);
            }
        }

        const ret: string[] = [];
        ret.push(url);
        let index = 0;
        for (let key in params) {
            if (index) {
                ret.push("&");
            } else {
                index = 1;
            }

            const value = params[key];
            if (!value) {
                continue;
            }

            if (value && (typeof value == "object")) {
                if (value instanceof Array) {
                    ret.push(encodeURIComponent(key), "=" + encodeURIComponent("["));
                    for (let i = 0; i < value.length; i++) {
                        if (i) {
                            ret.push(",");
                        }
                        ret.push(encodeURIComponent(value[i]));
                    }
                    ret.push(encodeURIComponent("]"));
                } else {
                    ret.push(encodeURIComponent(key), "=", encodeURIComponent(JSON.stringify(value)));
                }
            } else {
                ret.push(encodeURIComponent(key), "=", encodeURIComponent(value));
            }
        }
        url = ret.join("");

        return url;
    }
}
